import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../store/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./ManagePost.css"; // Add custom styles here

export default function ManageJobs() {
  const [jobs, setJobs] = useState([]);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [truncatedDescriptions, setTruncatedDescriptions] = useState({});

  const { user } = useAuth();

  const getJobs = useCallback(async () => {
    try {
      const response = await fetch(`https://in.quiko.in/api/sell/Jobs`, {
        method: "GET",
      });
      if (response.ok) {
        const data = await response.json();
        const filteredJobs = data.response_data.filter(
          (job) => job.email === user.email
        );
        setJobs(filteredJobs);
      }
    } catch (error) {
      console.log("service page error ", error);
    }
  }, [user]);

  const deleteJob = useCallback(
    async (id, imageUrl) => {
      try {
        const response = await fetch(
          `https://in.quiko.in/api/sell/jobs/delet/${id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${user.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ imageUrl }),
          }
        );
        if (response.ok) {
          setJobs((prevJobs) =>
            prevJobs.filter((job) => job._id !== id)
          );
          toast.success("Delete successful");
        } else {
          console.log("Failed to delete the job.");
        }
      } catch (error) {
        console.log("service page error ", error);
      }
    },
    [user]
  );

  const handleDeleteClick = (id, imageUrl) => {
    deleteJob(id, imageUrl);
  };

  useEffect(() => {
    if (user) {
      getJobs();
    }
  }, [user, getJobs]);

  const navigate = useNavigate();
  const handleCardClick = (_id) => {
    navigate(`/jobs/${_id}`);
  };
  
  const handleEditClick = (id) => {
    navigate(`/edit/jobs/${id}`);
  };

  const handleFeaturedPost = (_id, title, category) => {
    navigate(`/featuredpost`, {
      state: { email: user.email, postId: _id, postTitle: title , category: category},
    });
  };

  // ============= read more =============
  useEffect(() => {
    const truncatedDescriptions = {};
    jobs.forEach((product) => {
      if (product.description.length > 100) {
        truncatedDescriptions[product._id] = `${product.description.substring(0, 100)}...`;
      } else {
        truncatedDescriptions[product._id] = product.description;
      }
    });
    setTruncatedDescriptions(truncatedDescriptions);
  }, [jobs]);

  const handleReadMore = (id) => {
    setShowFullDescription((prevShowFullDescription) => ({ ...prevShowFullDescription, [id]: true }));
  };

  const handleShowLess = (id) => {
    setShowFullDescription((prevShowFullDescription) => ({ ...prevShowFullDescription, [id]: false }));
  };

  return jobs.map((curEle, index) => {
    const { _id, title, imageUrl, salaryfrom, aria, description, category } = curEle;
    return (
      <div className={"manage-post-container"} key={index}>
        <div className="post-image" onClick={() => handleCardClick(_id)}>
          <img src={`https://in.quiko.in/${imageUrl[0]}`} alt="Post" />
        </div>

        <div className="post-details">
          <div className="post-header">
            <h3>{title}</h3>
            <p className="post-description">
              {showFullDescription[_id] ? description : truncatedDescriptions[_id]}
              {description.length > 100 && !showFullDescription[_id] && (
                <span onClick={() => handleReadMore(_id)} style={{color:"blue"}}>read more</span>
              )}
              {showFullDescription[_id] && (
                <span onClick={() => handleShowLess(_id)} style={{color:"blue"}}>...show less</span>
              )}
            </p>
            <p className="post-location">Location: {aria}</p>
          </div>
          <div className="post-price">
            <h3>₹{salaryfrom}</h3>
          </div>
          <div
            className="post-actions"
            style={{ gap: "5px", display: "flex", flexDirection: "row" }}
          >
            <button
              className="delete-btn btn-3"
              onClick={() => handleDeleteClick(_id, imageUrl)}
            >
              Delete
            </button>
            <button
              className="custom-btn btn-2"
              onClick={() => handleEditClick(_id)}
            >
              Edit
            </button>
            <button className="promote-ad-btn btn-4">
            <button
                onClick={()=> handleFeaturedPost(_id, title, category)}
                style={{color:"white"}}
              >
                Featured
              </button>
            </button>
          </div>
        </div>
      </div>
    );
  });
}
